import Api_Usermanagement from '../api-usermanagement'

const api = new Api_Usermanagement().init()
const prefix = '/attachment'

const create = (module, data) => {
  return api.post(prefix + `/create/${module}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getFile = (module, id, credential) => {
  return api.get(prefix + `/all/${module}?attach_parent=${id}&credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getFileByOrder = (id) => {
  return api.get(
    prefix + `/get-by-order-sub/${id}?credentials=${localStorage.getItem('credential')}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const deleteFile = (id) => {
  return api.delete(prefix + `/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const notifFindoc = (id, user_id, status) => {
  return api.get(`/findoc/notif/decrement?id=${id}&user_id=${user_id}&status=${status}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

export {create, getFile, deleteFile, notifFindoc, getFileByOrder}
